import React from 'react';

interface BadgeProps {
  variant?: 'tool' | 'lecture' | 'complete' | 'current' | 'locked' | 'ninja' | 'default';
  children: React.ReactNode;
  className?: string;
}

export const Badge: React.FC<BadgeProps> = ({
  variant = 'default',
  children,
  className = '',
}) => {
  const getVariantClass = () => {
    switch (variant) {
      case 'tool': return 'badge-tool';
      case 'lecture': return 'badge-lecture';
      case 'complete': return 'badge-complete';
      case 'current': return 'badge-current';
      case 'locked': return 'badge-locked';
      case 'ninja': return 'badge-ninja';
      default: return 'badge-tool';
    }
  };

  return (
    <span className={`badge ${getVariantClass()} ${className}`}>
      {children}
    </span>
  );
};
